import React from 'react';
import { Box, List, ListItem, H2, Text, Image, ModalBody, ModalFooter, CompassColor, ModalContent, } from '@noom/wax-component-library';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../../../../core/components/Button';
export function WelcomeView({ isLoading, onSubmit, fireworksImageUrl }) {
    return (React.createElement(ModalContent, { bg: CompassColor.offWhite },
        React.createElement(ModalBody, { position: "relative" },
            React.createElement(Box, { textAlign: "center", mb: 8 },
                React.createElement(H2, { mb: 4, fontWeight: "500" },
                    React.createElement(FormattedMessage, { id: "onboarding.welcome.title" })),
                React.createElement(Text, null,
                    React.createElement(FormattedMessage, { id: "onboarding.welcome.subTitle", values: {
                            b: (text) => React.createElement("b", null, text),
                        } }))),
            React.createElement(List, null, [1, 2, 3, 4].map((key) => (React.createElement(ListItem, { key: key, mb: 4, sx: {
                    '&::marker': {
                        content: '"◆ "',
                        color: 'primary.500',
                    },
                } },
                React.createElement(FormattedMessage, { id: `onboarding.welcome.bullets.${key}`, values: {
                        b: (text) => (React.createElement(Text, { color: "primary.500", fontWeight: "bold" }, text)),
                    } }))))),
            fireworksImageUrl ? (React.createElement(Image, { src: fireworksImageUrl, position: "absolute", top: "-20%", w: "100%" })) : null),
        React.createElement(ModalFooter, null,
            React.createElement(PrimaryButton, { isFullWidth: true, isLoading: isLoading, onClick: onSubmit },
                React.createElement(FormattedMessage, { id: "onboarding.welcome.button" })))));
}
//# sourceMappingURL=WelcomeView.js.map